const selectAll = 'Select all that apply';
const howMuch = 'Number:';
const whenYouNeed = 'When:';
const amountToBorrow = 'How much do you need?';
const loanTiming = 'When do you need the money?';

export default {
  'surveyPage.meta.title.businessIndustry': 'Select Industry & Business Type Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessLocation': 'Years in Business & Zip Code Hancock Whitney Client Guide',
  'surveyPage.meta.title.employmentPosition': 'Select Your Business Role Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessLifeCycle': 'Select Business Cycle Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessGoods': 'Select How You Sell Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessCheckingBalance': 'Enter Deposit Balances Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessLoanBalance': 'Hancock Whitney Loan Balance Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessCheckingInterest.': 'Earn Interest on Business Checking Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessMonthlyExpenses': 'Volume for Payment Types Received Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessCashCollection': 'Enter Avg. Monthly Cash Collected Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessCheckDeposit': 'Select Check Deposit Methods Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessActiveMerchantAccount': 'Are You Merchant Services Client Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessMerchantAccount': 'Hancock Whitney Merchant Services Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessMonthlyPayments': 'Enter Volume for Payment Types Made Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessTrustAccount': 'Interest of Lawyers Trust Account Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessBorrowNeeds': 'Any Business Borrowing Needs Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessBorrowGoals': 'Funding Amount Needed by Reason Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessSecureLoan': 'Select Preference for Securing Loan Hancock Whitney Client Guide',
  'surveyPage.meta.title.reviewCreditCard': 'Interested in a Credit Card from Hancock Whitney Client Guide',
  'surveyPage.meta.title.reviewCreditOptions': 'Want to Discuss Credit Card Options Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessCreditMonthlySpending': 'Average Monthly Spend on Credit Card Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessCreditCardRewards': 'Select Most Important Card Feature Hancock Whitney Client Guide',
  'surveyPage.meta.title.businessCcRewardsWithLoan': 'Select Features of Credit Card Hancock Whitney Client Guide',

  /**
   * ============================
   * COMMON BUSINESS QUESTIONS
   * ============================
   */
  /* Question 1.1 */
  'isCustomer': 'Are you a current Hancock Whitney client?',
  'isCustomer.personal': 'Yes, personal',
  'isCustomer.business': 'Yes, business',
  'isCustomer.both': 'Yes, both business and personal',
  'isCustomer.none': 'No, not yet',

  /* Question 1.2 */
  'businessIndustry': 'Which industry best describes your business?',
  'businessIndustry.agriculture': 'Agriculture, Forestry and Fishing',
  'businessIndustry.construction': 'Construction',
  'businessIndustry.finance': 'Finance/Insurance',
  'businessIndustry.healthcare': 'Healthcare',
  'businessIndustry.foodServices': 'Food Services',
  'businessIndustry.hospitality': 'Hospitality',
  'businessIndustry.informationTechnology': 'Information Technology',
  'businessIndustry.legal': 'Legal',
  'businessIndustry.manufacturing': 'Manufacturing',
  'businessIndustry.mining': 'Mining / Oil & Gas',
  'businessIndustry.personalServices': 'Personal Services',
  'businessIndustry.professionalServices': 'Professional Services',
  'businessIndustry.publicAdministration': 'Public Administration',
  'businessIndustry.publishing': 'Publishing and Broadcasting',
  'businessIndustry.realEstate': 'Real Estate',
  'businessIndustry.religious': 'Religious/Civic Organization',
  'businessIndustry.repair': 'Repair and Maintenance',
  'businessIndustry.retail': 'Retail Trade',
  'businessIndustry.science': 'Science/Engineering',
  'businessIndustry.telecommunications': 'Telecommunications',
  'businessIndustry.transportation': 'Transportation/Warehousing',
  'businessIndustry.utilities': 'Utilities',
  'businessIndustry.wholesaleTrade': 'Wholesale Trade',
  'businessIndustry.other': 'Other',

  /* Question 1.3 */
  'businessType': 'What is your business structure?',
  'businessType.soleProprietor': 'Sole Proprietorship',
  'businessType.corporation': 'Corporation',
  'businessType.nonProfitCorporation': 'Non-Profit',
  'businessType.trust': 'Trust',
  'businessType.llp': 'Limited Liability Partnership',
  'businessType.llc': 'Limited Liability Company',
  'businessType.association': 'Association / Organization',
  'businessType.other': 'Other',

  /* Question 1.4 */
  'businessYears': 'Number of years in business?',

  /* Question 1.5 */
  'postalCode': "Zip code?",
  'postalCode.subtext': "We currently serve communities located near Hancock Whitney branch locations in the states of AL, FL, LA, MS and TX",
  'postalCode.definition': "Enter zip code",
  'postalCode.input.placeholder': "Enter your zip code (i.e. 75254)",

    /* Question 1.6 */
  'businessState': "State",
  'businessState.definition': "State",

  /* Question 1.7 */
  'employmentPosition': 'What is your role in the business?',
  'employmentPosition.owner': 'Owner',
  'employmentPosition.partner': 'Partner',
  'employmentPosition.seniorExecutive': 'Senior Executive',
  'employmentPosition.finance': 'Finance',
  'employmentPosition.other': 'Other',

  /* Question 1.8 */
  'businessEmployees': 'Number of Employees?',

  /* Question 1.9 */
  'businessAnnualIncome': 'What is your annual revenue?',

  /* Question 1.10 */
  'businessLifeCycle': 'Where are you in the business life cycle?',
  'businessLifeCycle.establishment': 'Establishment',
  'businessLifeCycle.growth': 'Growth',
  'businessLifeCycle.expansion': 'Expansion',
  'businessLifeCycle.maturity': 'Maturity',
  'businessLifeCycle.transition': 'Transition',

  /* Question 1.11 */
  'businessGoods': 'Where do you sell your goods and services?',
  'businessGoods.subtext': selectAll,
  'businessGoods.online': 'Online',
  'businessGoods.office': 'Office / Store',
  'businessGoods.field': 'In the field',
  'businessGoods.phone': 'Phone',
  'businessGoods.wholesale': 'Wholesale',
  'businessGoods.other': 'Other',

  /* Question 1.12 */
  'businessCheckingBalance': 'What is the minimum daily balance in your business\' checking account?',

  /* Question 1.13 */
  'businessSavingsBalance': 'What is the minimum daily balance in your business\' savings accounts, money markets, and CDs?',

  /* Question 1.14 */
  'businessLoanBalance': 'What are the remaining balances on any business loans with Hancock Whitney?',
  'businessLoanBalance.tooltip': "Enter '$0' if none",

  /* Question 1.15.0 */
  "businessSavingsOptions": "Are you looking for long term or short term savings options?",
  "businessSavingsOptions.short": "Short Term",
  "businessSavingsOptions.long": "Long Term",
  "businessSavingsOptions.both": "Both",

  /* Question 1.14 */
  'businessCheckingInterest': 'Is it important to earn interest on your business checking account?',
  'businessCheckingInterest.true': 'Yes',
  'businessCheckingInterest.false': 'No',

  /* Question 1.15 */
  'businessMonthlyExpensesGroup': 'On average, how many times monthly do your customers pay you using:',
  'businessMonthlyExpensesGroup.subtext': 'Add your information below.',
  'businessMonthlyExpensesTypes.cardBuilder.removeCard': '<i class="fa fa-times"></i>',
  'businessMonthlyExpensesTypes.cardBuilder.editCard': '<i class="fa fa-pencil"></i>',
  'businessMonthlyExpensesTypes.cardBuilder.addCard': 'Select',
  'businessMonthlyExpensesTypes.cardBuilder.saveCard': 'Save <i class="fa fa-caret-right"></i>',
  'businessMonthlyExpensesTypes.cardBuilder.modal.title': 'Estimate the average balances in your account(s):',
  'businessMonthlyExpensesTypes': 'Account Type',

  /* Question 1.15.1 */
  'businessMonthlyExpensesTypes.creditExpenses': 'Credit card',
  'businessMonthlyExpensesTypes.creditExpenses.image': '/classpath/assets/images/icon-creditcard.svg',
  'businessMonthlyExpensesTypes.creditExpenses.title': 'Credit Card',
  'creditExpenses.cardBuilder.title': 'Credit Card <small>(Number of times you are paid per month)</small>',

  'creditExpense': howMuch,
  'creditExpense.cardBuilder.answerLabel': howMuch,
  'details.creditExpense': `Credit balance | ${howMuch}`,

  /* Question 1.15.2 */
  'businessMonthlyExpensesTypes.debitExpenses': 'Debit card',
  'businessMonthlyExpensesTypes.debitExpenses.image': '/classpath/assets/images/icon-checking.svg',
  'businessMonthlyExpensesTypes.debitExpenses.title': 'Debit Card',
  'debitExpenses.cardBuilder.body': '<img src="/classpath/assets/images/icon-checking.svg" alt="wallet icon" />',
  'debitExpenses.cardBuilder.title': 'Debit card <small>(Number of times you are paid per month)</small>',

  'debitExpense': howMuch,
  'debitExpense.cardBuilder.answerLabel': howMuch,
  'details.debitExpense': `Debit balance | ${howMuch}`,

  /* Question 1.15.3 */
  'businessMonthlyExpensesTypes.checksExpenses': 'Checks',
  'businessMonthlyExpensesTypes.checksExpenses.image': '/classpath/assets/images/icon-check.svg',
  'businessMonthlyExpensesTypes.checksExpenses.title': 'Checks',
  'checksExpenses.cardBuilder.title': 'Checks <small>(Number of times you are paid per month)</small>',

  'checksExpense': howMuch,
  'checksExpense.cardBuilder.answerLabel': howMuch,
  'details.checksExpense': `Checks balance | ${howMuch}`,

  /* Question 1.15.4 */
  'businessMonthlyExpensesTypes.achExpenses': 'eCollection (ACH)',
  'businessMonthlyExpensesTypes.achExpenses.image': '/classpath/assets/images/icon-ecollection.svg',
  'businessMonthlyExpensesTypes.achExpenses.title': 'eCollection (ACH)',
  'achExpenses.cardBuilder.title': 'eCollection (ACH) <small>(Number of times you are paid per month)</small>',

  'achExpense': howMuch,
  'achExpense.cardBuilder.answerLabel': howMuch,
  'details.achExpense': `ACH balance | ${howMuch}`,

  /* Question 1.15.5 */
  'businessMonthlyExpensesTypes.wireExpenses': 'Wire Transfer',
  'businessMonthlyExpensesTypes.wireExpenses.image': '/classpath/assets/images/icon-transfer.svg',
  'businessMonthlyExpensesTypes.wireExpenses.title': 'Wire Transfer',
  'wireExpenses.cardBuilder.title': 'Wire Transfer <small>(Number of times you are paid per month)</small>',

  'wireExpense': howMuch,
  'wireExpense.cardBuilder.answerLabel': howMuch,
  'details.wireExpense': `Wire balance | ${howMuch}`,

  /* Question 1.16 */
  'averageMonthlyCashReceipts': 'How much cash do you collect in an average month?',
  'averageMonthlyCashReceipts.tooltip': "Enter '$0' if none",

  /* Question 1.17 */
  'businessCheckDeposit': 'How do you deposit checks?',
  'businessCheckDeposit.subtext': selectAll,
  'businessCheckDeposit.mobile': 'Mobile',
  'businessCheckDeposit.atm': 'ATM',
  'businessCheckDeposit.branch': 'Branch',
  'businessCheckDeposit.remote': 'Remote capture deposit',

  /* Question 1.18 */
  'businessActiveMerchantAccount': 'Do you have an active Merchant Services Account with Hancock Whitney?',
  'businessActiveMerchantAccount.true': 'Yes',
  'businessActiveMerchantAccount.false': 'No',

  /* Question 1.19 */
  'businessMerchantAccount': "You may be eligible to upgrade to our preferred checking account with a waiver of fees by using our in-house merchant program to process your customers' payments. {br} {br} May we have one of our Merchant specialists contact you to talk about our exciting program?",
  'businessMerchantAccount.true': 'Yes',
  'businessMerchantAccount.false': 'No',

  /* Question 1.20 */
  'businessMonthlyPaymentsGroup': 'How many times each month do you pay vendors and suppliers using:',
  'businessMonthlyPaymentsGroup.subtext': 'Add your information below.',
  'businessMonthlyPaymentsTypes.cardBuilder.removeCard': '<i class="fa fa-times"></i>',
  'businessMonthlyPaymentsTypes.cardBuilder.editCard': '<i class="fa fa-pencil"></i>',
  'businessMonthlyPaymentsTypes.cardBuilder.addCard': 'Select',
  'businessMonthlyPaymentsTypes.cardBuilder.saveCard': 'Save <i class="fa fa-caret-right"></i>',
  'businessMonthlyPaymentsTypes.cardBuilder.modal.title': 'Estimate the average balances in your account(s):',
  'businessMonthlyPaymentsTypes': 'Account Type',

  /* Question 1.20.1 */
  'businessMonthlyPaymentsTypes.credit': 'Credit card',
  'businessMonthlyPaymentsTypes.credit.image': '/classpath/assets/images/icon-creditcard.svg',
  'businessMonthlyPaymentsTypes.credit.title': 'Credit Card',
  'credit.cardBuilder.body': '<img src="/classpath/assets/images/icon-creditcard.svg" alt="credit card icon" />',
  'credit.cardBuilder.title': 'Credit Card <small>(Number of times you use to pay per month)</small>',

  'creditPayment': howMuch,
  'creditPayment.cardBuilder.answerLabel': howMuch,
  'details.creditPayment': `Credit balance | ${howMuch}`,

  /* Question 1.20.2 */
  'businessMonthlyPaymentsTypes.debitPayments': 'Debit card',
  'businessMonthlyPaymentsTypes.debitPayments.image': '/classpath/assets/images/icon-checking.svg',
  'businessMonthlyPaymentsTypes.debitPayments.title': 'Debit Card',
  'debitPayments.cardBuilder.body': '<img src="/classpath/assets/images/icon-checking.svg" alt="wallet icon" />',
  'debitPayments.cardBuilder.title': 'Debit Card <small>(Number of times you use to pay per month)</small>',

  'debitPayment': howMuch,
  'debitPayment.cardBuilder.answerLabel': howMuch,
  'details.debitPayment': `Debit balance | ${howMuch}`,

  /* Question 1.20.3 */
  'businessMonthlyPaymentsTypes.checks': 'Checks',
  'businessMonthlyPaymentsTypes.checks.image': '/classpath/assets/images/icon-check.svg',
  'businessMonthlyPaymentsTypes.checks.title': 'Checks',
  'checks.cardBuilder.body': '<img src="/classpath/assets/images/icon-check.svg" alt="check icon" />',
  'checks.cardBuilder.title': 'Checks <small>(Number of times you use to pay per month)</small>',

  'checksPayment': howMuch,
  'checksPayment.cardBuilder.answerLabel': howMuch,
  'details.checksPayment': `Checks balance | ${howMuch}`,

  /* Question 1.20.4 */
  'businessMonthlyPaymentsTypes.ach': 'ACH',
  'businessMonthlyPaymentsTypes.ach.image': '/classpath/assets/images/icon-ecollection.svg',
  'businessMonthlyPaymentsTypes.ach.title': 'ACH',
  'ach.cardBuilder.body': '<img src="/classpath/assets/images/icon-ecollection.svg" alt="cash register icon" />',
  'ach.cardBuilder.title': 'ACH <small>(Number of times you use to pay per month)</small>',

  'achPayment': howMuch,
  'achPayment.cardBuilder.answerLabel': howMuch,
  'details.achPayment': `ACH balance | ${howMuch}`,

  /* Question 1.20.5 */
  'businessMonthlyPaymentsTypes.wire': 'Wire Transfer',
  'businessMonthlyPaymentsTypes.wire.image': '/classpath/assets/images/icon-transfer.svg',
  'businessMonthlyPaymentsTypes.wire.title': 'Wire Transfer',
  'wire.cardBuilder.body': '<img src="/classpath/assets/images/icon-transfer.svg" alt="credit card with arrow icon" />',
  'wire.cardBuilder.title': 'Wire Transfer <small>(Number of times you use to pay per month)</small>',

  'wirePayment': howMuch,
  'wirePayment.cardBuilder.answerLabel': howMuch,
  'details.wirePayment': `Wire balance | ${howMuch}`,

  /* Question 1.21 */
  'businessTrustAccount': 'Are you interested in opening an IOLTA (Interest of Lawyers Trust Accounts) account?',
  'businessTrustAccount.true': 'Yes',
  'businessTrustAccount.false': 'No',

  /* Question 1.22 */
  'businessBorrowNeeds': 'Does your business have any borrowing needs to support current or future plans?',
  'businessBorrowNeeds.true': 'Yes',
  'businessBorrowNeeds.false': 'No',

  /* Question 1.23 */
  'businessBorrowGoalsGroup': 'Reason for funding?',
  'businessBorrowGoalsGroup.subtext': selectAll,
  'businessBorrowGoalsTypes.cardBuilder.addCard': 'Select',
  'businessBorrowGoalsTypes.cardBuilder.removeCard': '<i class="fa fa-times"></i>',
  'businessBorrowGoalsTypes.cardBuilder.editCard': '<i class="fa fa-pencil"></i>',
  'businessBorrowGoalsTypes.cardBuilder.saveCard': 'Save <i class="fa fa-caret-right"></i>',
  'businessBorrowGoalsTypes.cardBuilder.modal.title': 'Tell us about your goal:',
  'businessBorrowGoalsTypes': 'Select your goal:',
  /* Acquisition */
  'businessBorrowGoalsTypes.businessBorrowAcquisition': 'Acquisition',
  'businessBorrowGoalsTypes.businessBorrowAcquisition.image': '/classpath/assets/images/icon-acquisition.svg',
  'businessBorrowGoalsTypes.businessBorrowAcquisition.title': 'Acquisition',
  /* Debt Consolidation */
  'businessBorrowGoalsTypes.businessBorrowDebtConsolidation': 'Debt Consolidation',
  'businessBorrowGoalsTypes.businessBorrowDebtConsolidation.image': '/classpath/assets/images/icon-debt.svg',
  'businessBorrowGoalsTypes.businessBorrowDebtConsolidation.title': 'Debt Consolidation',
  /* Equipment */
  'businessBorrowGoalsTypes.businessBorrowEquipment': 'Equipment',
  'businessBorrowGoalsTypes.businessBorrowEquipment.image': '/classpath/assets/images/icon-equipment.svg',
  'businessBorrowGoalsTypes.businessBorrowEquipment.title': 'Equipment',
  /* Inventory */
  'businessBorrowGoalsTypes.businessBorrowInventory': 'Inventory',
  'businessBorrowGoalsTypes.businessBorrowInventory.image': '/classpath/assets/images/icon-review.svg',
  'businessBorrowGoalsTypes.businessBorrowInventory.title': 'Inventory',
  /* One-time Purchase */
  'businessBorrowGoalsTypes.businessBorrowPurchase': 'One-time Purchase',
  'businessBorrowGoalsTypes.businessBorrowPurchase.image': '/classpath/assets/images/icon-majorPurchase.svg',
  'businessBorrowGoalsTypes.businessBorrowPurchase.title': 'One-time Purchase',
  /* Real Estate */
  'businessBorrowGoalsTypes.businessBorrowRealEstate': 'Real Estate',
  'businessBorrowGoalsTypes.businessBorrowRealEstate.image': '/classpath/assets/images/icon-landing.svg',
  'businessBorrowGoalsTypes.businessBorrowRealEstate.title': 'Real Estate',
  /* Working Capital */
  'businessBorrowGoalsTypes.businessBorrowWorkingCapital': 'Working Capital',
  'businessBorrowGoalsTypes.businessBorrowWorkingCapital.image': '/classpath/assets/images/icon-capital.svg',
  'businessBorrowGoalsTypes.businessBorrowWorkingCapital.title': 'Working Capital',
  /* Vehicle */
  'businessBorrowGoalsTypes.businessBorrowVehicle': 'Vehicle',
  'businessBorrowGoalsTypes.businessBorrowVehicle.image': '/classpath/assets/images/icon-vehicle.svg',
  'businessBorrowGoalsTypes.businessBorrowVehicle.title': 'Vehicle',

  /* Question 1.23.1 - Acquisition */
  'businessBorrowAcquisition.cardBuilder.title': 'Acquisition',
  'businessBorrowAcquisition.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowAcquisitionAmount': 'Funding Amount?',
  'details.businessBorrowAcquisitionAmount': `Goals: Acquisition | ${amountToBorrow}`,
  'businessBorrowAcquisitionTiming': 'Timing of funding?',
  'businessBorrowAcquisitionTiming.upFront': 'Up Front',
  'businessBorrowAcquisitionTiming.overTime': 'Over time',
  'details.businessBorrowAcquisitionTiming': `Goals: Acquisition | ${loanTiming}`,
  'businessBorrowAcquisitionAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowAcquisitionTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.23.2 - Debt Consolidation */
  'businessBorrowDebtConsolidation.cardBuilder.title': 'Debt Consolidation',
  'businessBorrowDebtConsolidation.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowDebtConsolidationAmount': 'Funding Amount?',
  'details.businessBorrowDebtConsolidationAmount': `Goals: Debt Consolidation | ${amountToBorrow}`,
  'businessBorrowDebtConsolidationTiming': 'Timing of funding?',
  'businessBorrowDebtConsolidationTiming.upFront': 'Up Front',
  'businessBorrowDebtConsolidationTiming.overTime': 'Over time',
  'details.businessBorrowDebtConsolidationTiming': `Goals: Debt Consolidation | ${loanTiming}`,
  'businessBorrowDebtConsolidationAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowDebtConsolidationTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.23.3 - Equipment */
  'businessBorrowEquipment.cardBuilder.title': 'Equipment',
  'businessBorrowEquipment.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowEquipmentAmount': 'Funding Amount?',
  'details.businessBorrowEquipmentAmount': `Goals: Equipment | ${amountToBorrow}`,
  'businessBorrowEquipmentTiming': 'Timing of funding?',
  'businessBorrowEquipmentTiming.upFront': 'Up Front',
  'businessBorrowEquipmentTiming.overTime': 'Over time',
  'details.businessBorrowEquipmentTiming': `Goals: Equipment | ${loanTiming}`,
  'businessBorrowEquipmentAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowEquipmentTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.23.4 - Inventory */
  'businessBorrowInventory.cardBuilder.title': 'Inventory',
  'businessBorrowInventory.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowInventoryAmount': 'Funding Amount?',
  'details.businessBorrowInventoryAmount': `Goals: Inventory | ${amountToBorrow}`,
  'businessBorrowInventoryTiming': 'Timing of funding?',
  'businessBorrowInventoryTiming.upFront': 'Up Front',
  'businessBorrowInventoryTiming.overTime': 'Over time',
  'details.businessBorrowInventoryTiming': `Goals: Inventory | ${loanTiming}`,
  'businessBorrowInventoryAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowInventoryTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.23.5 - One Time Purchase */
  'businessBorrowPurchase.cardBuilder.title': 'One-time Purchase',
  'businessBorrowPurchase.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowPurchaseAmount': 'Funding Amount?',
  'details.businessBorrowPurchaseAmount': `Goals: One-time Purchase | ${amountToBorrow}`,
  'businessBorrowPurchaseTiming': 'Timing of funding?',
  'businessBorrowPurchaseTiming.upFront': 'Up Front',
  'businessBorrowPurchaseTiming.overTime': 'Over time',
  'details.businessBorrowPurchaseTiming': `Goals: One-time Purchase | ${loanTiming}`,
  'businessBorrowPurchaseAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowPurchaseTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.23.6 - Real Estate */
  'businessBorrowRealEstate.cardBuilder.title': 'Real Estate',
  'businessBorrowRealEstate.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowRealEstateAmount': 'Funding Amount?',
  'details.businessBorrowRealEstateAmount': `Goals: Real Estate | ${amountToBorrow}`,
  'businessBorrowRealEstateTiming': 'Timing of funding?',
  'businessBorrowRealEstateTiming.upFront': 'Up Front',
  'businessBorrowRealEstateTiming.overTime': 'Over time',
  'details.businessBorrowRealEstateTiming': `Goals: Real Estate | ${loanTiming}`,
  'businessBorrowRealEstateAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowRealEstateTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.23.7 - Working Capital */
  'businessBorrowWorkingCapital.cardBuilder.title': 'Working Capital',
  'businessBorrowWorkingCapital.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowWorkingCapitalAmount': 'Funding Amount?',
  'details.businessBorrowWorkingCapitalAmount': `Goals: Working Capital | ${amountToBorrow}`,
  'businessBorrowWorkingCapitalTiming': 'Timing of funding?',
  'businessBorrowWorkingCapitalTiming.upFront': 'Up Front',
  'businessBorrowWorkingCapitalTiming.overTime': 'Over time',
  'details.businessBorrowWorkingCapitalTiming': `Goals: Working Capital | ${loanTiming}`,
  'businessBorrowWorkingCapitalAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowWorkingCapitalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.23.7 - Vehicle */
  'businessBorrowVehicle.cardBuilder.title': 'Vehicle',
  'businessBorrowVehicle.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'businessBorrowVehicleAmount': 'Funding Amount?',
  'details.businessBorrowVehicleAmount': `Goals: Vehicle | ${amountToBorrow}`,
  'businessBorrowVehicleTiming': 'Timing of funding?',
  'businessBorrowVehicleTiming.upFront': 'Up Front',
  'businessBorrowVehicleTiming.overTime': 'Over time',
  'details.businessBorrowVehicleTiming': `Goals: Vehicle | ${loanTiming}`,
  'businessBorrowVehicleAmount.cardBuilder.answerLabel': howMuch,
  'businessBorrowVehicleTiming.cardBuilder.answerLabel': whenYouNeed,

  /* Question 1.24 */
  'businessSecureLoan': 'Business loans over $100,000 require collateral. How do you prefer to secure your loan?',
  'businessSecureLoan.realEstate': 'Real Estate',
  'businessSecureLoan.equipment': 'Equipment',
  'businessSecureLoan.deposit': 'Current Hancock Whitney Deposit Account',
  'businessSecureLoan.home': 'Personal Home',
  'businessSecureLoan.none': 'None',

  /* Question 1.27 */
  'reviewCreditCard': 'You mentioned using a Credit Card, are you interested in discussing a Credit Card with Hancock Whitney?',
  'reviewCreditCard.true': 'Yes',
  'reviewCreditCard.false': 'No',

  /* Question 1.28 */
  'reviewCreditOptions': 'Are you interested in discussing a Credit Card with Hancock Whitney?',
  'reviewCreditOptions.true': 'Yes',
  'reviewCreditOptions.false': 'No',

  /* Question 1.29 */
  'businessCreditMonthlySpending': 'How much do you spend monthly using a Credit Card?',

  /* Question 1.30 */
  'businessCreditCardRewards': 'Which feature of a business card program would interest you more?',
  'businessCreditCardRewards.rate': 'Low Rate',
  'businessCreditCardRewards.rewards': 'Rewards Program',

  /* Question 1.31 */
  'businessCcRewardsWithLoan': 'Based on your borrowing needs you would be a good fit for a Business Credit Card. Which feature of a business card program would interest you more?',
  'businessCcRewardsWithLoan.rate': 'Low Rate',
  'businessCcRewardsWithLoan.rewards': 'Rewards Program',

};
